'use client';

import { ProductListSort } from '@/types/api';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { useBasicMetas } from '@/app/(plp)/_utils/use-basic-metas';
import usePLPData from '@/app/(plp)/_utils/use-plp-data';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import DesktopSortList from './desktop-sort-list';
import SortListLoading from './loading';
import MobileSortList from './mobile-sort-list';
interface Props {
  defaultState?: ProductListSort;
}
export const SortList = ({
  defaultState
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    setSortBy,
    filterChangeByUserRef
  } = usePLPFacetsContext();
  const {
    isLoading
  } = usePLPData();
  const defaultSelected = defaultState ? defaultState : ProductListSort.MostVisited;
  const isLoadingBasicMetas = useBasicMetas().isLoadingBasicMetas;
  if (isLoading || isLoadingBasicMetas) return <SortListLoading />;
  if (!setSortBy) return null;
  const handleStateChange = (newState: ProductListSort) => {
    setSortBy(newState);
    filterChangeByUserRef.current = true;
  };
  const isSelected = !!defaultState;
  return isMobile ? <MobileSortList isSelected={isSelected} defaultSelected={defaultSelected} changeHandler={handleStateChange} data-sentry-element="MobileSortList" data-sentry-component="SortList" data-sentry-source-file="index.tsx" /> : <DesktopSortList isSelected={isSelected} defaultSelected={defaultSelected} changeHandler={handleStateChange} data-sentry-element="DesktopSortList" data-sentry-component="SortList" data-sentry-source-file="index.tsx" />;
};
export default SortList;